import { Box, Stack, Typography, useMediaQuery } from "@mui/material";
import parse from "html-react-parser";
import React from "react";

import SlideTransition from "../SlideTransition";
import SectionLayout from "../../layouts/SectionLayout";

import useContent from "../../hooks/useContent";
import useInView from "../../hooks/useInView";

import { styles } from "./style";
import { theme } from "../../utils/theme";

const Challenge = () => {
  const content = useContent();
  const matches = useMediaQuery((theme) => theme.breakpoints.down("md"));
  const [setRef, visible] = useInView({
    threshold: 0.5,
  });

  return (
    <SectionLayout
      style={{
        backgroundColor: theme.palette.grays[100],
        pb: { xs: 4, md: 40 },
        pt: { xs: 6, md: 32 },
      }}
    >
      <Box ref={setRef} sx={styles.item}>
        <Box
          sx={{
            background: `url(${content.challenge.image})`,
            backgroundAttachment: "fixed",
            backgroundPosition: "bottom left !important",
            backgroundRepeat: "no-repeat !important",
            backgroundSize: `${
              matches ? "cover !important" : "cover !important"
            }`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            filter: "brightness(1) grayscale(0.3)",
            height: { xs: 360, sm: "100%", md: "100%" },
            width: { xs: "95vw", md: "50%" },
          }}
        />

        <Stack sx={styles.itemContentContainer}>
          <SlideTransition appear={visible} timeout={700}>
            <Typography sx={styles.itemContentHeader}>
              {content.challenge.header}
            </Typography>
          </SlideTransition>

          <SlideTransition appear={visible} timeout={600}>
            <Typography sx={styles.itemContentBody}>
              {parse(content.challenge.content)}
            </Typography>
          </SlideTransition>
        </Stack>
      </Box>
    </SectionLayout>
  );
};

export default Challenge;
